module.exports = __webpack_public_path__ + "static/media/international.f3fe5156.png";